<script>
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  mounted() {
    this.renderChart(
      {
        labels: ["B&B", "Nice2Stay", "H&B"],
        datasets: [
          {
            data: [50, 25, 25],
            backgroundColor: ["#30c771", "#d14949", "#556ee6"],
            hoverBackgroundColor: ["#30c771", "#d14949", "#556ee6"],
            hoverBorderColor: "#fff",
          },
        ],
      },
      {
        maintainAspectRatio: true,
        responsive: true,
      }
    );
  },
};
</script>
